<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("ESTABLISHMENTS.EDIT_ESTABLISHMENT") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <establishment-form
              :loading="loading"
              :establishmentData="establishment"
              :formErrors="formErrors"
              @establishmentSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import EstablishmentForm from "./partials/EstablishmentForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultEstablishment from "./defaultEstablishment";

export default {
  layout: "DashboardLayout",

  components: { EstablishmentForm },

  mixins: [alertLeave],

  data() {
    return {
      establishment: cloneDeep(defaultEstablishment),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("establishments/get", id);
        this.establishment =
          this.$store.getters["establishments/establishment"];
        if (!this.establishment.coordinator) {
          this.establishment.coordinator = { type: "users", id: null };
        }
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Establishments" });
    },

    viewEstablishment() {
      this.alertLeave = false;
      this.$router.push({
        name: "View Establishment",
        params: { id: this.establishment.id },
      });
    },

    async handleSubmit(establishment) {
      this.loading = true;
      const establishmentData = cloneDeep(establishment);

      try {
        await this.$store.dispatch("establishments/update", establishmentData);
        this.$notify({
          type: "success",
          message: this.$t("ESTABLISHMENTS.ESTABLISHMENT_UPDATED"),
        });
        this.viewEstablishment();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
